import _ from 'lodash';

const directiveName = 'ltValidatePassword';
const directive = [() => {

	const INVALID_CHAR_REGEXP = /[^a-zA-Z0-9!$%&()*+-.\\;:<=>?@\]}_|~]/;

	return {
		require: 'ngModel',
		scope: {
			username: '=ltValidatePasswordUsername'
		},
		link: (scope: IValidatePasswordScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes, ctrl: ng.INgModelController) => {

			ctrl.$validators.password = (modelValue: string, viewValue: string) => {
				if (ctrl.$isEmpty(modelValue)) {
					return true;
				}

				// Passwords must be 10 to 30 characters, not have any spaces and contain at least one letter (A-Z) and one number (0-9)
				return modelValue.length >= 10 && modelValue.length <= 30 && /[a-zA-Z]/.test(modelValue) && /[0-9]/.test(modelValue) && !/\s/.test(modelValue);
			};

			ctrl.$validators.passwordCharacters = (modelValue: string, viewValue: string) => {
				if (ctrl.$isEmpty(modelValue)) {
					return true;
				}

				// Passwords must not contain invalid characters
				return !INVALID_CHAR_REGEXP.test(modelValue);
			};

			ctrl.$validators.passwordUsername = (modelValue: string, viewValue: string) => {
				const username = scope.username;

				if (ctrl.$isEmpty(modelValue) || ctrl.$isEmpty(username)) {
					return true;
				}

				return !_.includes(modelValue.toLowerCase(), username.toLowerCase());
			};

		}
	} as ng.IDirective<IValidatePasswordScope, ng.IAugmentedJQuery, ng.IAttributes, ng.INgModelController>;
}];

interface IValidatePasswordScope extends ng.IScope {
	username: string;
}

export default function(module: ng.IModule): void {
	module.directive(directiveName, directive);
}
